import { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import EvidenceModal from "./EvidenceModal";

export default function BadgesModal({ badges = [], courseName }) {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(0);
  if (!badges.length) return null;
  const current = badges[selected];
  return (
    <>
      <button
        type="button"
        className="evidence-trigger"
        onClick={() => {
          setSelected(0);
          setShow(true);
        }}
      >
        {t("certificates.viewBadges")}
      </button>
      <EvidenceModal
        show={show}
        onHide={() => setShow(false)}
        title={
          courseName
            ? `${courseName} · ${t("certificates.viewBadges")}`
            : t("certificates.viewBadges")
        }
      >
        <div className="badge-stage">
          <img src={current.src} alt={current.alt} />
        </div>
        <div className="badge-caption" aria-live="polite">
          <p>{current.alt}</p>
          <span>
            {selected + 1} / {badges.length}
          </span>
        </div>
        {badges.length > 1 && (
          <>
            <div className="badge-navigation">
              <button
                type="button"
                disabled={selected === 0}
                onClick={() => setSelected((index) => index - 1)}
              >
                {t("evidence.previous")}
              </button>
              <button
                type="button"
                disabled={selected === badges.length - 1}
                onClick={() => setSelected((index) => index + 1)}
              >
                {t("evidence.next")}
              </button>
            </div>
            <div
              className="badge-thumbnails"
              role="group"
              aria-label={t("evidence.chooseBadge")}
            >
              {badges.map((badge, index) => (
                <button
                  type="button"
                  key={badge.src}
                  aria-label={badge.alt}
                  aria-pressed={selected === index}
                  onClick={() => setSelected(index)}
                >
                  <img src={badge.src} alt="" loading="lazy" />
                </button>
              ))}
            </div>
          </>
        )}
      </EvidenceModal>
    </>
  );
}
